import { render, staticRenderFns } from "./StockInvoiceSourcesPanel.vue?vue&type=template&id=18540b24&scoped=true"
import script from "./StockInvoiceSourcesPanel.vue?vue&type=script&lang=js"
export * from "./StockInvoiceSourcesPanel.vue?vue&type=script&lang=js"
import style0 from "./StockInvoiceSourcesPanel.vue?vue&type=style&index=0&id=18540b24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18540b24",
  null
  
)

export default component.exports